import React, { useState } from "react";
import Instrument_Check_Form from "./instrument_Check_Form/Instrument_Check_Form";
import Instrument_Check_table from "./instrument_Check_table/Instrument_Check_table";

function Instrument_Check() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Instrument_Check_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Instrument_Check_table/>
        </div>
      )}
    </>
  );
}

export default Instrument_Check;
